import { Pipe, PipeTransform } from '@angular/core';

interface TrackByFunctionCache {
  [propertyName: string]: <T>(index: number, item: T) => any;
}

const cache: TrackByFunctionCache = Object.create(null);

@Pipe({
  name: 'trackByProperty'
})
export class TrackByPropertyPipe implements PipeTransform {
  public transform(propertyName: string) {
    if (!cache[propertyName]) {
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      cache[propertyName] = function trackByProperty<T>(index: number, item: T): any {
        return item[propertyName];
      };
    }

    return cache[propertyName];
  }
}
